import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

import { apiHost } from '../../../config';
import downloadFile from '../../../lib/downloadFile';
import uploadFile from '../../../lib/uploadFile';
import handleApiErrors from '../../../lib/apiClient/handleErrors';

import AddCard from '../../../components/common/AddCard/Card';
import ExcelFileCard from '../../../components/common/ExcelFileCard/Card';
import withPopupErrors from '../../../components/HOC/withPopupErrors/withPopupErrors';

interface ImportsPageProps {
  showError: (text: string) => void;
  unauthorizedCallback: () => void;
}

const ImportsPage = ({ showError, unauthorizedCallback }: ImportsPageProps) => {
  const [waiting, setWaiting] = useState(false);

  const downloadImportTemplate = () => {
    if (waiting) return;
    setWaiting(true);

    handleApiErrors(
      downloadFile(
        `${apiHost}/xlsx/teachers_import_template`,
        'Шаблон загрузки учителей.xlsx',
      )
        .then(() => setWaiting(false))
        .catch(() => {
          setWaiting(false);
          showError('Ошибка на сервере');
        }),
      unauthorizedCallback,
      showError,
    );
  };

  const exportTeachers = () => {
    if (waiting) return;
    setWaiting(true);

    handleApiErrors(
      downloadFile(`${apiHost}/api/admin/users/xlsx`, 'Учителя.xlsx')
        .then(() => setWaiting(false))
        .catch(() => {
          setWaiting(false);
          showError('Ошибка на сервере');
        }),
      unauthorizedCallback,
      showError,
    );
  };

  const uploadTeachers = () => {
    if (waiting) return;
    setWaiting(true);

    uploadFile(
      `${apiHost}/api/admin/users/xlsx`,
      'teachers',
      'teachers.xlsx',
      '.xlsx',
    )
      .then(() => {
        setWaiting(false);
        alert('Учителя успешно загружены');
      })
      .catch(({ message }) => {
        setWaiting(false);

        if (message === 'Unauthorized' || message === 'Forbidden') {
          unauthorizedCallback();
        } else {
          showError(message);
        }
      });
  };

  return (
    <>
      {waiting && (
        <Spinner
          animation="border"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 80,
            height: 80,
            marginTop: '-40px',
            marginLeft: '-40px',
          }}
        >
          <span className="visually-hidden">Импорт учеников...</span>
        </Spinner>
      )}
      <div style={{ width: '720px' }}>
        <section>
          <div className="d-flex justify-content-between align-items-center gap-4 mb-5">
            <h4>Импорт</h4>
            <hr className="flex-grow-1" />
          </div>

          <div className="d-flex gap-5 mb-5">
            <AddCard onClick={uploadTeachers} />
            <ExcelFileCard
              filename="Шаблон.xlsx"
              download={downloadImportTemplate}
            />
          </div>
        </section>

        <section>
          <div className="d-flex justify-content-between align-items-center gap-4 mb-5">
            <h4>Экспорт</h4>
            <hr className="flex-grow-1" />
          </div>

          <ExcelFileCard filename="Учителя.xlsx" download={exportTeachers} />
        </section>
      </div>
    </>
  );
};

export default withPopupErrors<ImportsPageProps>(ImportsPage);
